import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const TransferIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest} viewBox="0 0 24 24">
      <path
        d="M19.5 17.5C19.5 18.8807 18.3807 20 17 20C15.6193 20 14.5 18.8807 14.5 17.5C14.5 16.1193 15.6193 15 17 15C18.3807 15 19.5 16.1193 19.5 17.5Z"
        stroke="currentColor"
        strokeWidth={1}
      />
      <path
        d="M9.5 17.5C9.5 18.8807 8.38071 20 7 20C5.61929 20 4.5 18.8807 4.5 17.5C4.5 16.1193 5.61929 15 7 15C8.38071 15 9.5 16.1193 9.5 17.5Z"
        stroke="currentColor"
        strokeWidth={1}
      />
      <path
        d="M14.5 17.5H9.5M19.5 17.5H20.2632C20.4831 17.5 20.5931 17.5 20.6855 17.4885C21.3669 17.4036 21.9036 16.8669 21.9885 16.1855C22 16.0931 22 15.9831 22 15.7632V13C22 9.41015 19.0899 6.5 15.5 6.5M2 4H12C13.4142 4 14.1213 4 14.5607 4.43934C15 4.87868 15 5.58579 15 7V15.5M2 12.75V15C2 15.9346 2 16.4019 2.20096 16.75C2.33261 16.978 2.52197 17.1674 2.75 17.299C3.09808 17.5 3.56538 17.5 4.5 17.5"
        stroke="currentColor"
        strokeWidth={1}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2 7H8M2 10H6" stroke="currentColor" strokeWidth={1} strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  )
}
